/* global SideDrawer */

class QuickBuyDrawer extends SideDrawer {
  connectedCallback() {
    document.addEventListener('dispatch:quickbuy-drawer:open', (evt) => {
      this.openForProduct(evt.detail.productUrl, evt.detail.opener);
    });

    this.addEventListener('on:cart:add', () => {
      const cartDrawer = document.querySelector('.js-cart-drawer');
      const isCartDrawerOpen = cartDrawer && cartDrawer.hasAttribute('open');
      this.close();
      if (isCartDrawerOpen) {
        this.overlay.classList.add('is-visible');
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      }
    });
  }

  async openForProduct(productUrl, opener) {
    const inner = this.querySelector('.quick-buy-drawer__inner');
    inner.innerHTML = '<div class="loading-spinner"></div>';

    if (this.hasAttribute('open')) {
      this.opener = opener;
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
      this.open(opener);
    }

    theme.quickBuy.currentRequestAbortController?.abort('Replaced by new request');
    const ctrl = new AbortController();
    theme.quickBuy.currentRequestAbortController = ctrl;

    try {
      const response = await fetch(productUrl, { signal: ctrl.signal });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const html = await response.text();

      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;
      const newDetail = tmpl.content.querySelector('.quickbuy-content').cloneNode(true);

      tmpl.content.querySelectorAll('.section-size-guide').forEach((el) => {
        if (el.querySelector('.modal--for-size-guide')) {
          newDetail.insertAdjacentElement('beforeend', el.cloneNode(true));
        } else {
          const sizeGuide = el.querySelector('[data-modal-template]').content.querySelector('size-guide').cloneNode(true);
          sizeGuide.querySelector('.modal__content').appendChild(el.querySelector('.size-guide__content'));
          newDetail.insertAdjacentElement('beforeend', sizeGuide);
        }
      });

      theme.quickBuy.convertToQuickBuyContent(newDetail, productUrl);

      tmpl.content.querySelectorAll(':is(.section-main-product, .section-size-guide) link[rel="stylesheet"]').forEach((el) => {
        if (!document.querySelector(`link[rel="stylesheet"][href="${el.getAttribute('href')}"]`)) {
          document.head.insertAdjacentHTML('beforeend', el.outerHTML);
        }
      });
      tmpl.content.querySelectorAll(':is(.section-main-product, .section-size-guide) script[src]').forEach((el) => {
        if (!document.querySelector(`script[src="${el.getAttribute('src')}"]`)) {
          const scr = document.createElement('script');
          scr.src = el.getAttribute('src');
          scr.defer = true;
          document.head.appendChild(scr);
        }
      });

      const quickBuyWrapper = document.createElement('div');
      quickBuyWrapper.className = 'js-quickbuy';
      quickBuyWrapper.dataset.productUrl = productUrl;
      quickBuyWrapper.appendChild(newDetail);

      inner.innerHTML = '';
      inner.appendChild(quickBuyWrapper);
      theme.manuallyLoadImages(inner);
    } catch (error) {
      console.warn(error); // eslint-disable-line no-console
    }
  }
}

window.customElements.define('quick-buy-drawer', QuickBuyDrawer);
